import { Heading } from "@chakra-ui/react"
import AvatarStack from "@pathwright/ui/src/components/avatar/AvatarStack"
import classnames from "classnames"
import styled from "styled-components"
import InboxNavigatorItemReviewCount from "./InboxNavigatorItemReviewCount"
import { InboxGroupNode } from "./useInboxItems"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  position: relative;
  cursor: pointer;
  padding: var(--chakra-spacing-2);

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .InboxNavigatorItemReviewCount {
    margin-left: 1em;
    font-size: 1.2em;
  }

  .Button__content-wrapper {
    .CountIndicator {
      position: absolute;
      top: 0px;
      right: 0px;
    }
  }
`

const IdentifierContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;

  h1 {
    margin: 0;
  }

  h1 + div {
    display: flex;
    align-items: center;

    h2 {
      margin: 0;
      margin-left: 0.4em;
    }
  }
`

const InboxNavigatorItemMeta = ({ item }: { item: InboxGroupNode }) => (
  <IdentifierContainer className="InboxNavigatorItem__meta">
    <Heading as="h1" size="lg" lineClamp={1} mb={0.5}>
      {item.meta.title}
    </Heading>
    <div>
      <AvatarStack
        users={[...item.users.staff, ...item.users.members]}
        size="1.6em"
        itemOffset="-0.4em"
      />
      {/* <AvatarStack users={item.users.members} size="1.6em" itemOffset="-0.4em" /> */}
      <Heading as="h2" size="sm" lineClamp={1} color="gray.500">
        {item.meta.subtitle}
      </Heading>
    </div>
  </IdentifierContainer>
)

const InboxNavigatorItem = ({
  className,
  item,
  onSelect
}: {
  className?: string
  item: InboxGroupNode
  onSelect: () => void
}) => (
  <Container
    className={classnames(
      "InboxNavigatorItem",
      `InboxNavigatorItem__${item.type}`,
      className
    )}
    onClick={onSelect}
  >
    <InboxNavigatorItemMeta item={item} />
    <InboxNavigatorItemReviewCount item={item} />
  </Container>
)

InboxNavigatorItem.displayName = "InboxNavigatorItem"

export default InboxNavigatorItem
